import { useIntl } from "react-intl";

const PageInsights = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.pageInsights.header",
            defaultMessage: "Page insights"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.pageInsights.content",
            defaultMessage:
                "Get engagement analytics on page views and user views."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.pageInsights.altText",
            defaultMessage: "Example of page insights"
        }),
        caption: intl.formatMessage({
            id: "ConfluencePricingPage.features.pageInsights.caption",
            defaultMessage:
                "Here’s a quick view of page insights in Confluence."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/page-insights.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
            <p>{messages.caption}</p>
        </>
    );
};

export default PageInsights;
